"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _Node = _interopRequireDefault(require("./Node"));

var _locale = require("../locale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var List =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(List, _Component);

  function List(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};
    _this.getText = _this.getText.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = List.prototype;

  _proto.getKey = function getKey(data, index) {
    var _this$props = this.props,
        keygen = _this$props.keygen,
        parentId = _this$props.parentId;
    if (typeof keygen === 'function') return keygen(data, parentId);
    if (keygen) return data[keygen];
    return parentId + (parentId ? ',' : '') + index;
  };

  _proto.getText = function getText(key) {
    return this.props.text[key] || (0, _locale.getLocale)(key);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        data = _this$props2.data,
        other = _objectWithoutPropertiesLoose(_this$props2, ["data"]);

    if (!data || data.length === 0) return _react.default.createElement("span", {
      className: (0, _styles.cascaderClass)('no-data')
    }, this.getText('noData'));
    return _react.default.createElement("div", {
      className: (0, _styles.cascaderClass)('list')
    }, data.map(function (d, i) {
      var id = _this2.getKey(d, i);

      return _react.default.createElement(_Node.default, _extends({}, other, {
        key: id,
        active: other.id === id,
        id: id,
        data: d
      }));
    }));
  };

  return List;
}(_react.Component);

List.propTypes = {
  data: _propTypes.default.array,
  id: _propTypes.default.string,
  keygen: _propTypes.default.any,
  onNodeClick: _propTypes.default.func,
  parentId: _propTypes.default.string,
  text: _propTypes.default.object
};
List.defaultProps = {
  id: '',
  parentId: '',
  text: {}
};
var _default = List;
exports.default = _default;